module.exports = __webpack_public_path__ + "static/ROIcalculator-f4c513639b51bfc85b0463ecdd5a5fbd.png";